import { t } from '../i18nService';

function setStream(video, stream) {
    if (typeof video === 'object' && video && video.srcObject !== stream) {
        video.srcObject = stream;
        video.play();
        return true;
    }

    return false;
}

function mapPropsToProps({ alreadyCaptured }) {
    const buttonLabelKey = alreadyCaptured
        ? 'idVerification.captureDevice.retakePhoto'
        : 'idVerification.captureDevice.takePhoto';

    return { buttonLabel: t(buttonLabelKey) };
}

export {
    mapPropsToProps,
    setStream,
};
